var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilWithStarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 25,
    height: 26,
    rx: 12.5,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.375 8.625C6.725 8.4 7.4 7.5 7.625 6.375C7.85 7.5 8.525 8.4 9.875 8.625C8.525 8.85 7.85 9.75 7.625 10.875C7.4 9.75 6.725 8.85 5.375 8.625Z",
    fill: "#5D5D5D",
    stroke: "#5D5D5D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74735 16.8924L7.38833 19.0464C7.34175 19.3259 7.31847 19.4656 7.3618 19.5666C7.39973 19.6551 7.47019 19.7256 7.55862 19.7634C7.65965 19.8068 7.79937 19.7835 8.0788 19.737L10.2329 19.3779C10.7963 19.284 11.078 19.2371 11.3409 19.1408C11.5741 19.0553 11.7958 18.9412 12.001 18.801C12.2321 18.6432 12.4341 18.4412 12.838 18.0373L18.5002 12.375C19.5358 11.3395 19.5358 9.66057 18.5002 8.62504C17.4647 7.58951 15.7858 7.58951 14.7502 8.62504L9.08793 14.2873C8.68405 14.6912 8.48211 14.8932 8.32421 15.1243C8.18408 15.3294 8.06997 15.5511 7.9845 15.7844C7.8882 16.0473 7.84125 16.329 7.74735 16.8924Z",
    stroke: "#5D5D5D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 9.75L17.375 12.75",
    stroke: "#5D5D5D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilWithStarIcon);
export default __webpack_public_path__ + "static/media/pencilWithStarIcon.1221a514d03195e5d07380092df73948.svg";
export { ForwardRef as ReactComponent };